import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import Select from 'react-select';
// IntegracaoConfig removido da UI por segurança (credenciais SQL Server não devem ser expostas no frontend)

import './../../../../i18n/config';
import { useTranslation } from 'react-i18next';
import empresaNovaService from '../../../services/empresaNovaService';
import IntegracaoService from '../../../services/IntegracaoService';
import EspelhoReferencial from './components/EspelhoReferencial';
import { PageTitle, useLayout } from '../../../../_metronic/layout/core';
import { DefaultTitle } from '../../../../_metronic/layout/components/header/page-title/DefaultTitle';

const colunasKanban = [
    'Empresas cadastradas',
    'Importação de ECD',
    'Carga de Saldo Inicial',
    'Posição financeira',
    'Estoque',
    'Hospedagem em Curso',
    'Tributos',
    'Imobilizados',
    'Folha de pagamento',
    'Disponível para conferência',
];

const colunasUploadManual = ['Tributos'];
const colunasInativas = ['Imobilizados', 'Folha de pagamento'];

// Meta por coluna: barra de progresso e rótulo do card (a coluna em si vem do backend).
const colunaMeta: Record<string, { percentual: string; valor: string }> = {
    'Empresas cadastradas': { percentual: '5%', valor: 'Sem período importado' },
    'Importação de ECD': { percentual: '30%', valor: 'Importando ECD' },
    'Carga de Saldo Inicial': { percentual: '55%', valor: 'Saldo inicial carregado' },
    'Posição financeira': { percentual: '75%', valor: 'Posição financeira importada' },
    'Estoque': { percentual: '90%', valor: 'Conciliando estoque' },
    'Hospedagem em Curso': { percentual: '95%', valor: 'Importando borderô da hospedagem' },
    'Disponível para conferência': { percentual: '100%', valor: 'Completo' },
};

const configuracaoColunas = [
    { headerColor: '#F59E0B', bodyColor: '#FFF7E8' },
    { headerColor: '#0EA5E9', bodyColor: '#F0F9FF' },
    { headerColor: '#10B981', bodyColor: '#ECFDF5' },
    { headerColor: '#EF4444', bodyColor: '#FEF2F2' },
    { headerColor: '#0D9488', bodyColor: '#F0FDFA' },
    { headerColor: '#6366F1', bodyColor: '#EEF2FF' },
    { headerColor: '#F97316', bodyColor: '#FFF7ED' },
    { headerColor: '#14B8A6', bodyColor: '#F0FDFA' },
    { headerColor: '#8B5CF6', bodyColor: '#F5F3FF' },
    { headerColor: '#22C55E', bodyColor: '#F0FDF4' },
];

interface EmpresaStatus {
    id: number;
    chave1: number | null;
    razaoSocial: string | null;
    nomeFantasia: string | null;
    cnpj: string;
    esteiraAtiva: boolean;
    esteiraId: number | null;
    etapa: number;
    importando: boolean;
    porcentagem: number;
    periodoInicio?: string | null;
    periodoFim?: string | null;
    coluna?: string;
    semEsteira?: boolean;
    temPlanoContas: boolean;
    temLancamentos: boolean;
    temSaldos: boolean;
    temPosicaoFinanceira: boolean;
    temTributos: boolean;
    temImobilizados: boolean;
    temFolha: boolean;
    temSaldoInicial: boolean;
    bloqueadoPosicaoFinanceira?: boolean;
    bloqueios?: Record<string, string>;
}

interface KanbanCard {
    id: number;
    codigo: string;
    titulo: string;
    cnpj: string;
    periodo: string;
    percentual: string;
    valor: string;
    importando: boolean;
    empresa: EmpresaStatus;
    bloqueios?: Record<string, string>;
}

const formatarCnpj = (cnpj: string): string => {
    if (!cnpj) return '';
    const num = cnpj.replace(/\D/g, '');
    if (num.length === 14) {
        return num.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
    return cnpj;
};

const formatarMesAno = (data?: string | null): string => {
    if (!data) return '';
    const d = new Date(data);
    if (isNaN(d.getTime())) return '';
    return `${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
};

const formatarPeriodo = (inicio?: string | null, fim?: string | null): string => {
    const i = formatarMesAno(inicio);
    const f = formatarMesAno(fim);
    if (!i && !f) return '';
    return `${i} – ${f}`;
};

const stepStatusCor: Record<string, string> = {
    PROCESSANDO: '#F59E0B',
    CONCLUIDO: '#22C55E',
    ERRO: '#EF4444',
};

const Integracao = () => {
    const { classes } = useLayout();
    const { t } = useTranslation();
    const history = useHistory();
    const [tab, setTab] = useState<'kanban' | 'sienge' | 'config' | 'logs' | 'referencial'>('kanban');
    const [loading, setLoading] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState(true);
    const [status, setStatus] = useState<any>(null);
    const [hoveredColuna, setHoveredColuna] = useState<string | null>(null);
    const [empresaDetalhe, setEmpresaDetalhe] = useState<EmpresaStatus | null>(null);

    // Sienge
    const [empresas, setEmpresas] = useState<any[]>([]);
    const [empresasOffset, setEmpresasOffset] = useState(0);
    const [empresasPerPage] = useState(20);
    const [empresasQ, setEmpresasQ] = useState('');
    const [hasMoreEmpresas, setHasMoreEmpresas] = useState(true);
    const [loadingEmpresas, setLoadingEmpresas] = useState(false);
    const [empresaSelecionada, setEmpresaSelecionada] = useState(0);
    const [dataInicialSienge, setDataInicialSienge] = useState('');
    const [dataFinalSienge, setDataFinalSienge] = useState('');
    const anoAtual = new Date().getFullYear();
    const [dataInicial, setDataInicial] = useState(`${anoAtual}-01-01`);
    const [dataFinal, setDataFinal] = useState(`${anoAtual}-12-31`);

    // Integração do cliente logado; sem resposta fica a 1 (Atlântica), como era antes.
    const [integracaoId, setIntegracaoId] = useState(1);
    const [semEcd, setSemEcd] = useState(false);
    const [empresaSelecionadaGeral, setEmpresaSelecionadaGeral] = useState(0);

    useEffect(() => {
        IntegracaoService.minha()
            .then((integracao) => {
                if (!integracao) return;
                setIntegracaoId(integracao.id);
                setSemEcd(integracao.semEcd);
            })
            .catch(() => undefined);
    }, []);

    // Histórico da integração (steps) do card aberto no modal
    const [steps, setSteps] = useState<any[]>([]);
    const [loadingSteps, setLoadingSteps] = useState(false);
    const stepsPollingRef = useRef<ReturnType<typeof setInterval> | null>(null);

    const loadStatus = useCallback(async () => {
        try {
            const result = await IntegracaoService.statusAtlantica();
            setStatus(result);
        } catch {
            console.log("erro")
        } finally {
            setLoadingStatus(false);
        }
    }, []);

    const pollingRef = useRef<ReturnType<typeof setInterval> | null>(null);
    const temImportando = useMemo(() => {
        const importando = status?.empresas?.some((emp: any) => emp.importando) ?? false;
        return importando || (status?.sincronizacaoEmpresasEmAndamento ?? false);
    }, [status]);

    useEffect(() => {
        const load = async () => {
            setLoadingEmpresas(true);
            try {
                const result = await empresaNovaService.buscarEmpresasIntegracao(empresasOffset, empresasPerPage, empresasQ);
                if (empresasOffset === 0) {
                    setEmpresas(result);
                } else {
                    setEmpresas(prev => [...prev, ...result]);
                }
                setHasMoreEmpresas(result.length === empresasPerPage);
            } catch {
                if (empresasOffset === 0) setEmpresas([]);
            } finally {
                setLoadingEmpresas(false);
            }
        };
        load();
    }, [empresasOffset, empresasPerPage, empresasQ]);

    useEffect(() => {
        loadStatus();
    }, [loadStatus]);

    useEffect(() => {
        if (temImportando && tab === 'kanban') {
            pollingRef.current = setInterval(() => {
                loadStatus();
            }, 10000);
        }
        return () => {
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
                pollingRef.current = null;
            }
        };
    }, [temImportando, tab, loadStatus]);

    // Histórico da integração: carrega ao abrir o modal do card e faz polling enquanto houver step em processamento.
    useEffect(() => {
        if (!empresaDetalhe?.id) {
            setSteps([]);
            return;
        }

        let cancelado = false;
        const carregar = async () => {
            try {
                const result = await IntegracaoService.steps(empresaDetalhe.id);
                if (cancelado) return;
                setSteps(Array.isArray(result) ? result : []);
                const processando = (result || []).some((s: any) => s.status === 'PROCESSANDO');
                if (!processando && stepsPollingRef.current) {
                    clearInterval(stepsPollingRef.current);
                    stepsPollingRef.current = null;
                }
            } catch {
                if (!cancelado) setSteps([]);
            }
        };

        setLoadingSteps(true);
        carregar().finally(() => { if (!cancelado) setLoadingSteps(false); });
        stepsPollingRef.current = setInterval(carregar, 10000);

        return () => {
            cancelado = true;
            if (stepsPollingRef.current) {
                clearInterval(stepsPollingRef.current);
                stepsPollingRef.current = null;
            }
        };
    }, [empresaDetalhe?.id]);

    // A coluna do card vem calculada do backend (status.empresas[].coluna). Fallback defensivo:
    const resolverColuna = (emp: EmpresaStatus): string => {
        if (emp.coluna && colunasKanban.includes(emp.coluna)) return emp.coluna;
        if (emp.semEsteira) return 'Empresas cadastradas';
        if (emp.importando) return 'Importação de ECD';
        return 'Carga de Saldo Inicial';
    };

    const cardsPorColuna = useMemo(() => {
        const resultado: Record<string, KanbanCard[]> = {};

        colunasKanban.forEach((coluna) => {
            resultado[coluna] = [];
        });

        if (Array.isArray(status?.empresas)) {
            status.empresas.forEach((esteira: any, index: number) => {
                const coluna = resolverColuna(esteira);
                const meta = colunaMeta[coluna] || { percentual: '0%', valor: coluna };

                resultado[coluna]?.push({
                    id: esteira.id || 0,
                    codigo: String(esteira.empresaID || index + 1).padStart(3, '0'),
                    titulo: esteira.razaoSocial || esteira.nomeFantasia || 'Empresa',
                    cnpj: esteira.cnpj || '',
                    periodo: esteira.semEsteira ? '' : formatarPeriodo(esteira.periodoInicio, esteira.periodoFim),
                    percentual: esteira.importando ? '30%' : meta.percentual,
                    valor: esteira.importando ? 'Importando...' : meta.valor,
                    importando: esteira.importando,
                    empresa: esteira,
                });
            });
        }

        return resultado;
    }, [status]);

    const syncEmpresas = useCallback(async () => {
        setLoading(true);
        try {
            await IntegracaoService.cadastrarEmpresas(integracaoId);
            Swal.fire({ text: 'Cadastro de empresas iniciado. O Kanban será atualizado automaticamente.', icon: 'success', timer: 3000, showConfirmButton: false });
            setTimeout(loadStatus, 3000);
            setTimeout(loadStatus, 8000);
        } catch (e: any) {
            Swal.fire({ text: e.message || 'Erro ao cadastrar empresas.', icon: 'error', timer: 5000, showConfirmButton: false });
        }
        setLoading(false);
    }, [integracaoId, loadStatus]);

    const importarEmpresa = useCallback(async (empresaId: number, dtIni?: string, dtFim?: string) => {
        const di = dtIni || dataInicial;
        const df = dtFim || dataFinal;
        if (!di || !df) {
            Swal.fire({ text: 'Preencha data inicial e final.', icon: 'warning', timer: 3000 });
            return;
        }
        setLoading(true);
        try {
            // Mesmo período inicial de uma importação que já existe (e final igual ou maior):
            // pergunta se mantém a conciliação já feita em vez de começar do zero.
            // Integração sem ECD (barramento AX) não parte de esteira anterior: não há o que manter.
            let manterDados = false;
            const reaproveitamento = semEcd
                ? { podeManter: false }
                : await IntegracaoService.verificarReaproveitamento(integracaoId, empresaId, di, df);
            if (reaproveitamento.podeManter) {
                const resposta = await Swal.fire({
                    title: 'Manter os dados da importação existente?',
                    html: `Já existe uma importação desta empresa para o período <b>${formatarPeriodo(reaproveitamento.periodoInicio, reaproveitamento.periodoFim)}</b>.<br/><br/>`
                        + 'Se mantiver, os lançamentos que continuam iguais na origem ficam com a conciliação que já foi feita. '
                        + 'Uma nova esteira é criada e a anterior fica guardada como histórico.',
                    icon: 'question',
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Manter dados',
                    denyButtonText: 'Importar do zero',
                    cancelButtonText: 'Cancelar',
                });
                if (resposta.isDismissed) return;
                manterDados = resposta.isConfirmed;
            }

            await IntegracaoService.integrarAtlantica(integracaoId, empresaId, di, df, manterDados);
            Swal.fire({ text: 'Importação individual iniciada.', icon: 'success', timer: 2000, showConfirmButton: false });
            setTimeout(loadStatus, 3000);
        } catch (e: any) {
            Swal.fire({ text: e.message, icon: 'error', timer: 5000, showConfirmButton: false });
        } finally {
            setLoading(false);
        }
    }, [integracaoId, semEcd, dataInicial, dataFinal, loadStatus]);

    const sendFormSienge = useCallback(async () => {
        setLoading(true);
        if (!empresaSelecionada || !dataInicialSienge || !dataFinalSienge) {
            Swal.fire({ text: 'Preencha todos os campos.', icon: 'error', timer: 3000, showConfirmButton: false });
        } else {
            try {
                await IntegracaoService.integrar(empresaSelecionada, dataInicialSienge, dataFinalSienge);
                Swal.fire({ text: 'Integração Sienge iniciada.', icon: 'success', timer: 3000, showConfirmButton: false });
            } catch (e: any) {
                Swal.fire({ text: e.message, icon: 'error', timer: 5000, showConfirmButton: false });
            }
        }
        setLoading(false);
    }, [empresaSelecionada, dataInicialSienge, dataFinalSienge]);

    const renderEtapaBadges = (emp: EmpresaStatus) => {
        const badges: Array<{ label: string; ok: boolean }> = [
            { label: 'Plano', ok: emp.temPlanoContas },
            { label: 'Lanç.', ok: emp.temLancamentos },
            { label: 'Saldos', ok: emp.temSaldos },
            { label: 'Saldo Ini.', ok: emp.temSaldoInicial },
            { label: 'Posição', ok: emp.temPosicaoFinanceira },
            { label: 'Tributos', ok: emp.temTributos },
            { label: 'Imob.', ok: emp.temImobilizados },
            { label: 'Folha', ok: emp.temFolha },
        ];
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px', marginTop: '6px' }}>
                {badges.map((b) => (
                    <span key={b.label} style={{
                        fontSize: '9px', padding: '1px 5px', borderRadius: '4px',
                        background: b.ok ? '#DCFCE7' : '#F1F5F9',
                        color: b.ok ? '#166534' : '#94A3B8',
                        fontWeight: 600,
                    }}>{b.label}</span>
                ))}
            </div>
        );
    };

    const optionsEmpresas = useMemo(() => {
        return empresas.map((emp: any) => ({
            value: emp.id,
            label: `${emp.razaoSocial || emp.nomeFantasia} - ${emp.cnpj}`
        }));
    }, [empresas]);

    const handleSelectScroll = () => {
        if (hasMoreEmpresas) {
            setEmpresasOffset(prev => prev + empresasPerPage);
        }
    };

    const handleSelectSearch = (val: string, actionMeta: any) => {
        if (actionMeta.action === 'input-change') {
            setEmpresasQ(val);
            setEmpresasOffset(0);
        }
    };

    return <>
        <PageTitle breadcrumbs={[]}>{t('Integrar Empresas')}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
            </div>
        </div>

        <div className="mb-4"></div>

        {tab === 'kanban' && (
            <div>
                {loadingStatus && (
                    <div className="text-center p-5">
                        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }} />
                        <p className="mt-3 text-muted">Carregando dados da integração...</p>
                    </div>
                )}

                {!loadingStatus && status?.sincronizacaoEmpresasEmAndamento && (
                    <div className="alert d-flex align-items-center gap-2 mb-4" style={{ background: '#FEF3C7', color: '#92400E', border: '1px solid #FCD34D', borderRadius: '10px' }}>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        <span style={{ fontWeight: 600 }}>Sincronização de empresas em andamento… aguarde a conclusão para iniciar outra.</span>
                    </div>
                )}

                {!loadingStatus && status && (
                    <div className="card mb-4" style={{ borderRadius: '12px', border: 'none', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
                        <div className="card-body p-4">
                            <div className="row g-3 align-items-end">
                                <div className="col-auto">
                                    <button className="btn btn-sm" style={{ backgroundColor: '#10B981', color: '#fff', height: '38px' }} disabled={loading || status?.sincronizacaoEmpresasEmAndamento} onClick={syncEmpresas}>
                                        {loading || status?.sincronizacaoEmpresasEmAndamento ? '...' : 'Sincronizar Empresas'}
                                    </button>
                                </div>
                                <div className="col-auto">
                                    <button className="btn btn-sm btn-light-primary" style={{ height: '38px' }} onClick={() => setTab('referencial')}
                                        title="Espelho da conta contábil com a conta referencial (planilha ou cadastro manual)">
                                        Configurar referencial
                                    </button>
                                </div>
                                <div className="col" style={{ minWidth: '300px' }}>
                                    <label className="form-label mb-1" style={{ fontSize: '12px', color: '#64748B', fontWeight: 600 }}>{t('Empresa para Importação')}</label>
                                    <Select
                                        options={optionsEmpresas}
                                        value={optionsEmpresas.find(opt => opt.value === empresaSelecionadaGeral) || null}
                                        onChange={(selected: any) => setEmpresaSelecionadaGeral(selected?.value || 0)}
                                        onInputChange={handleSelectSearch}
                                        onMenuScrollToBottom={handleSelectScroll}
                                        placeholder={t('Selecione a empresa para iniciar')}
                                        isClearable
                                        isLoading={loadingEmpresas}
                                        styles={{ control: (base) => ({ ...base, height: '38px', minHeight: '38px', borderRadius: '6px' }) }}
                                        noOptionsMessage={() => "Nenhuma empresa encontrada"}
                                    />
                                </div>
                                <div className="col-auto">
                                    <label className="form-label mb-1" style={{ fontSize: '12px', color: '#64748B', fontWeight: 600 }}>Data Inicial</label>
                                    <input type="date" className="form-control form-control-sm" style={{ height: '38px', width: '150px' }}
                                        value={dataInicial} onChange={e => setDataInicial(e.target.value)} />
                                </div>
                                <div className="col-auto">
                                    <label className="form-label mb-1" style={{ fontSize: '12px', color: '#64748B', fontWeight: 600 }}>Data Final</label>
                                    <input type="date" className="form-control form-control-sm" style={{ height: '38px', width: '150px' }}
                                        value={dataFinal} onChange={e => setDataFinal(e.target.value)} />
                                </div>
                            </div>
                            <hr className="my-4" style={{ opacity: 0.1 }} />
                            <div className="d-flex gap-3 justify-content-center">
                                <button className="btn px-5" disabled={!empresaSelecionadaGeral || loading}
                                    style={{ backgroundColor: '#00B7A1', color: '#fff', fontWeight: 700, borderRadius: '8px' }}
                                    onClick={() => importarEmpresa(empresaSelecionadaGeral)}>
                                    {loading ? (
                                        <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Aguarde...</>
                                    ) : 'IMPORTAR AGORA'}
                                </button>
                            </div>
                            <p className="text-center text-muted mt-2 mb-0" style={{ fontSize: '11px' }}>
                                A posição financeira é importada automaticamente logo após a importação dos dados.
                            </p>
                        </div>
                    </div>
                )}

                {!loadingStatus && status && (
                    <div className="d-flex gap-3 mb-4 flex-wrap">
                        {[
                            { valor: status.totalEmpresas, label: 'Total Empresas', cor: '#00B7A1', tooltip: 'Total de empresas cadastradas neste cliente' },
                            { valor: status.comEsteira, label: 'Com Esteira', cor: '#3B82F6', tooltip: 'Empresas que já possuem esteira ativa (processo de importação iniciado)' },
                            { valor: status.semEsteira, label: 'Sem Esteira', cor: '#dc3545', tooltip: 'Empresas cadastradas mas ainda sem esteira — clique em "Importar" para iniciar' },
                            { valor: status.empresas?.filter((e: any) => e.importando).length || 0, label: 'Importando', cor: '#F59E0B', tooltip: 'Empresas com importação em andamento neste momento' },
                            { valor: status.empresas?.filter((e: any) => e.etapa >= 9).length || 0, label: 'Completas', cor: '#22C55E', tooltip: 'Empresas que passaram por todas as etapas de importação' },
                        ].map((item, idx) => (
                            <div key={idx} className="text-center" title={item.tooltip}
                                style={{ background: '#fff', borderRadius: '12px', padding: '14px 20px', minWidth: '130px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', cursor: 'default' }}>
                                <div style={{ fontSize: '24px', fontWeight: 700, color: item.cor, lineHeight: 1.2 }}>{item.valor}</div>
                                <div style={{ fontSize: '12px', color: '#64748B', marginTop: '2px' }}>{item.label}</div>
                            </div>
                        ))}
                    </div>
                )}

                {!loadingStatus && (
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div className="d-flex gap-2 align-items-center">
                            <button className="btn btn-sm btn-light" onClick={loadStatus} title="Atualizar">
                                &#x21bb; Atualizar Kanban
                            </button>
                            {temImportando && (
                                <span style={{
                                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                                    padding: '4px 12px', borderRadius: '999px',
                                    background: '#DCFCE7', color: '#166534', fontWeight: 600, fontSize: '12px',
                                }}>
                                    <span style={{
                                        width: '8px', height: '8px', borderRadius: '50%', background: '#22C55E',
                                        animation: 'pulse 1.5s infinite',
                                    }} />
                                    MONITORAMENTO AO VIVO
                                </span>
                            )}
                        </div>
                    </div>
                )}

                {!loadingStatus && status && (
                    <div className='card' style={{ borderRadius: '14px', border: '1px solid #E4E6EF', boxShadow: '0 2px 10px rgba(15, 23, 42, 0.04)' }}>
                        <div className='card-body' style={{ padding: '18px' }}>
                            <div style={{ overflowX: 'auto', overflowY: 'hidden', paddingBottom: '12px' }}>
                                <div style={{ display: 'flex', gap: '14px', minWidth: 'max-content', alignItems: 'stretch' }}>
                                    {colunasKanban.map((coluna, index) => {
                                        const configuracao = configuracaoColunas[index];
                                        const cards = cardsPorColuna[coluna] || [];
                                        const colunaUpload = colunasUploadManual.includes(coluna);
                                        const colunaInativa = colunasInativas.includes(coluna);

                                        return (
                                            <div
                                                key={coluna}
                                                onMouseEnter={() => setHoveredColuna(coluna)}
                                                onMouseLeave={() => setHoveredColuna(null)}
                                                style={{
                                                    width: '250px', minWidth: '250px',
                                                    background: colunaInativa ? '#F1F5F9' : colunaUpload ? '#F8FAFC' : configuracao.bodyColor,
                                                    border: colunaInativa ? '1px solid #CBD5E1' : colunaUpload ? '1px solid #CBD5E1' : '1px solid #DDE3EA',
                                                    borderRadius: '14px', overflow: 'visible',
                                                    display: 'flex', flexDirection: 'column',
                                                    height: '620px', position: 'relative',
                                                    opacity: colunaInativa ? 0.55 : colunaUpload ? 0.85 : 1,
                                                    transition: 'opacity 0.2s',
                                                }}
                                            >
                                                <div style={{
                                                    background: colunaInativa ? '#94A3B8' : colunaUpload ? '#64748B' : configuracao.headerColor,
                                                    color: '#FFFFFF', padding: '10px 12px',
                                                    borderRadius: '14px 14px 0 0',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                    fontWeight: 700, fontSize: '13px', minHeight: '42px',
                                                    fontFamily: 'Cairo, sans-serif',
                                                }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', maxWidth: 'calc(100% - 40px)' }}>
                                                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            {coluna}
                                                        </span>
                                                        {colunaInativa && (
                                                            <span style={{
                                                                fontSize: '9px', padding: '2px 6px', borderRadius: '999px',
                                                                background: 'rgba(255,255,255,0.25)', letterSpacing: '0.4px',
                                                            }}>INATIVO</span>
                                                        )}
                                                        {colunaUpload && !colunaInativa && (
                                                            <span style={{
                                                                fontSize: '9px', padding: '2px 6px', borderRadius: '999px',
                                                                background: 'rgba(255,255,255,0.18)', letterSpacing: '0.4px',
                                                            }}>UPLOAD</span>
                                                        )}
                                                    </div>
                                                    <span style={{
                                                        minWidth: '28px', height: '24px', padding: '0 8px', borderRadius: '999px',
                                                        background: 'rgba(255,255,255,0.22)', display: 'flex', alignItems: 'center',
                                                        justifyContent: 'center', fontSize: '12px', fontWeight: 700,
                                                    }}>
                                                        {cards.length}
                                                    </span>
                                                </div>

                                                <div style={{
                                                    padding: '8px', flex: 1, overflowY: 'auto',
                                                    display: 'flex', flexDirection: 'column', gap: '8px',
                                                }}>
                                                    {colunaInativa ? (
                                                        <div style={{
                                                            minHeight: '80px',
                                                            border: '1px dashed #CBD5E1',
                                                            borderRadius: '10px',
                                                            background: '#FFFFFF',
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            color: '#94A3B8', fontSize: '14px', fontWeight: 600,
                                                            marginTop: '2px',
                                                        }}>
                                                            <span>INATIVO</span>
                                                        </div>
                                                    ) : cards.length > 0 ? (
                                                        cards.map((card) => (
                                                            <div key={card.id}
                                                                onClick={() => setEmpresaDetalhe(card.empresa)}
                                                                style={{
                                                                    background: '#FFFFFF', borderRadius: '10px',
                                                                    border: card.importando ? '2px solid #F59E0B' : '1px solid #DCE3EA',
                                                                    boxShadow: '0 1px 4px rgba(15, 23, 42, 0.06)',
                                                                    padding: '10px 12px', cursor: 'pointer',
                                                                    transition: 'box-shadow 0.15s, transform 0.15s',
                                                                }}
                                                                onMouseEnter={e => {
                                                                    (e.currentTarget as HTMLDivElement).style.boxShadow = '0 4px 12px rgba(15, 23, 42, 0.12)';
                                                                    (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-1px)';
                                                                }}
                                                                onMouseLeave={e => {
                                                                    (e.currentTarget as HTMLDivElement).style.boxShadow = '0 1px 4px rgba(15, 23, 42, 0.06)';
                                                                    (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)';
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '4px' }}>
                                                                    <span style={{ fontSize: '22px', lineHeight: 1, fontWeight: 400, color: '#0F172A' }}>
                                                                        {card.codigo}
                                                                    </span>
                                                                    {card.importando && (
                                                                        <span style={{
                                                                            fontSize: '9px', padding: '2px 6px', borderRadius: '4px',
                                                                            background: '#FEF3C7', color: '#92400E', fontWeight: 700,
                                                                        }}>IMPORTANDO</span>
                                                                    )}
                                                                </div>
                                                                <div style={{
                                                                    fontSize: '12px', color: '#1E293B', minHeight: '32px', lineHeight: '16px',
                                                                    textTransform: 'uppercase', overflow: 'hidden',
                                                                    display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                                                                    marginBottom: '4px', fontWeight: 500,
                                                                }}>
                                                                    {card.titulo}
                                                                </div>
                                                                <div style={{ fontSize: '10px', color: '#94A3B8', marginBottom: '2px' }}>
                                                                    {formatarCnpj(card.cnpj)}
                                                                </div>
                                                                {card.periodo && (
                                                                    <div style={{ fontSize: '10px', color: '#64748B', marginBottom: '6px', fontWeight: 600 }}>
                                                                        Período: {card.periodo}
                                                                    </div>
                                                                )}
                                                                <div style={{ width: '100%', height: '4px', background: '#E9EEF5', borderRadius: '999px', marginBottom: '6px', overflow: 'hidden' }}>
                                                                    <div style={{
                                                                        width: card.percentual, height: '100%',
                                                                        background: card.importando ? '#F59E0B' : configuracao.headerColor,
                                                                        borderRadius: '999px', transition: 'width 0.5s',
                                                                    }} />
                                                                </div>
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '11px' }}>
                                                                    <span style={{ color: '#64748B' }}>{card.percentual}</span>
                                                                    <span style={{ color: '#0F172A', fontWeight: 600 }}>{card.valor}</span>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div style={{
                                                            minHeight: '80px',
                                                            border: colunaUpload ? '1px dashed #CBD5E1' : '1px dashed #D4DCE6',
                                                            borderRadius: '10px',
                                                            background: colunaUpload ? '#FFFFFF' : 'rgba(255,255,255,0.25)',
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            color: colunaUpload ? '#94A3B8' : '#A1A9B6',
                                                            fontSize: colunaUpload ? '13px' : '14px',
                                                            fontWeight: colunaUpload ? 700 : 400, marginTop: '2px',
                                                            textTransform: colunaUpload ? 'uppercase' : 'none',
                                                        }}>
                                                            <span>{colunaUpload ? 'Upload manual' : 'Vazio'}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )}

        {tab === 'referencial' && <EspelhoReferencial onVoltar={() => setTab('kanban')} />}

        {tab === 'sienge' && (
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card p-4">
                        <div className="mb-3">
                            <label className="form-label">{t('Empresa')}</label>
                            <Select
                                options={optionsEmpresas}
                                value={optionsEmpresas.find(opt => opt.value === empresaSelecionada) || null}
                                onChange={(selected: any) => setEmpresaSelecionada(selected?.value || 0)}
                                onInputChange={handleSelectSearch}
                                onMenuScrollToBottom={handleSelectScroll}
                                placeholder={t('Selecione uma empresa')}
                                isClearable
                                isLoading={loadingEmpresas}
                                noOptionsMessage={() => "Nenhuma empresa encontrada"}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t('Data Inicial')}</label>
                            <input type="date" className="form-control" value={dataInicialSienge} onChange={e => setDataInicialSienge(e.target.value)} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t('Data Final')}</label>
                            <input type="date" className="form-control" value={dataFinalSienge} onChange={e => setDataFinalSienge(e.target.value)} />
                        </div>
                        <div className="d-flex gap-2">
                            <button className="btn btn-success" disabled={loading} onClick={sendFormSienge}>{t('Integrar')}</button>
                            <button className="btn btn-success" disabled={loading} onClick={async () => {
                                setLoading(true);
                                try {
                                    await IntegracaoService.cadastrarEmpresas(integracaoId);
                                    const result = await empresaNovaService.buscarEmpresasIntegracao(empresasOffset, empresasPerPage, empresasQ);
                                    setEmpresas(result);
                                    Swal.fire({ text: 'Sincronizando as empresas.', icon: 'success', timer: 2000, showConfirmButton: false });
                                } catch {
                                    Swal.fire({ text: 'Erro.', icon: 'error', timer: 3000, showConfirmButton: false });
                                }
                                setLoading(false);
                            }}>{t('Sincronizar Empresas')}</button>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {empresaDetalhe && (
            <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(15, 23, 42, 0.4)', zIndex: 9999,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                backdropFilter: 'blur(4px)',
            }} onClick={() => setEmpresaDetalhe(null)}>
                <div className="card shadow-lg" style={{ width: '640px', maxWidth: '92vw', maxHeight: '88vh', overflow: 'hidden', borderRadius: '16px', border: 'none', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
                    <div className="card-header d-flex justify-content-between align-items-center py-4 px-5" style={{ background: '#F8FAFC', borderRadius: '16px 16px 0 0' }}>
                        <h3 className="card-title fw-bolder text-dark m-0" style={{ fontSize: '18px' }}>Detalhes da Integração</h3>
                        <button className="btn btn-icon btn-sm btn-active-light-primary" onClick={() => setEmpresaDetalhe(null)}>
                            <i className="bi bi-x fs-2"></i>
                        </button>
                    </div>
                    <div className="card-body p-5" style={{ overflowY: 'auto' }}>
                        <div className="d-flex align-items-center mb-5">
                            <div className="symbol symbol-50px me-4">
                                <span className="symbol-label bg-light-primary text-primary fw-bold" style={{ fontSize: '20px' }}>
                                    {empresaDetalhe.razaoSocial?.substring(0, 1) || 'E'}
                                </span>
                            </div>
                            <div className="d-flex flex-column">
                                <span className="text-dark fw-bold fs-5">{empresaDetalhe.razaoSocial}</span>
                                <span className="text-muted fw-semibold fs-7">CNPJ: {formatarCnpj(empresaDetalhe.cnpj)}</span>
                                {formatarPeriodo(empresaDetalhe.periodoInicio, empresaDetalhe.periodoFim) && (
                                    <span className="text-muted fw-semibold fs-7">Período: {formatarPeriodo(empresaDetalhe.periodoInicio, empresaDetalhe.periodoFim)}</span>
                                )}
                            </div>
                        </div>
                        <div className="row g-4 mb-5">
                            <div className="col-6">
                                <div className="bg-light p-3 rounded-3">
                                    <div className="text-muted fs-8 fw-bold text-uppercase mb-1">Status Atual</div>
                                    <div className="text-dark fw-bold">{resolverColuna(empresaDetalhe)}</div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="bg-light p-3 rounded-3">
                                    <div className="text-muted fs-8 fw-bold text-uppercase mb-1">Progresso</div>
                                    <div className="text-dark fw-bold">{empresaDetalhe.porcentagem}% Concluído</div>
                                </div>
                            </div>
                        </div>
                        <div className="mb-5">
                            <label className="form-label fw-bold text-dark fs-7 mb-2">Checklist de Integração</label>
                            <div className="d-flex flex-wrap gap-2">
                                {renderEtapaBadges(empresaDetalhe)}
                            </div>
                        </div>
                        <div>
                            <label className="form-label fw-bold text-dark fs-7 mb-2">Histórico da Integração</label>
                            {loadingSteps && steps.length === 0 ? (
                                <div className="text-muted fs-7 py-2">Carregando histórico…</div>
                            ) : steps.length === 0 ? (
                                <div className="text-muted fs-7 py-2">Sem histórico registrado.</div>
                            ) : (
                                <div className="d-flex flex-column gap-2">
                                    {steps.map((s: any) => (
                                        <div key={s.id} style={{ border: '1px solid #E4E6EF', borderRadius: '10px', padding: '10px 12px', background: s.status === 'ERRO' ? '#FEF2F2' : '#FFFFFF' }}>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="fw-bold text-dark fs-7">{s.titulo}</span>
                                                <span style={{
                                                    fontSize: '10px', padding: '2px 8px', borderRadius: '999px', fontWeight: 700,
                                                    background: (stepStatusCor[s.status] || '#94A3B8') + '22',
                                                    color: stepStatusCor[s.status] || '#64748B',
                                                }}>{s.status}</span>
                                            </div>
                                            <div className="text-muted mt-1" style={{ fontSize: '11px' }}>
                                                {s.dataInicio && <>Início: {new Date(s.dataInicio).toLocaleString('pt-BR')}</>}
                                                {s.dataFim && <> · Fim: {new Date(s.dataFim).toLocaleString('pt-BR')}</>}
                                                {typeof s.registros === 'number' && <> · {s.registros} registro(s)</>}
                                            </div>
                                            {s.mensagem && <div className="text-dark mt-1" style={{ fontSize: '11px' }}>{s.mensagem}</div>}
                                            {s.detalheErro && (
                                                <pre style={{ fontSize: '10px', margin: '6px 0 0', whiteSpace: 'pre-wrap', wordBreak: 'break-all', color: '#991B1B', maxHeight: '160px', overflow: 'auto' }}>{s.detalheErro}</pre>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="card-footer d-flex justify-content-end py-4 px-5 bg-light-soft" style={{ borderRadius: '0 0 16px 16px' }}>
                        <button className="btn btn-sm btn-secondary px-4" onClick={() => setEmpresaDetalhe(null)}>Fechar</button>
                    </div>
                </div>
            </div>
        )}



        <style>{`
            @keyframes pulse {
                0%, 100% { opacity: 1; }
                50% { opacity: 0.4; }
            }
        `}</style>
    </>;
};

export default Integracao;
